module.exports = __webpack_public_path__ + "static/our_team_pic-c07208d3e192df8b79661f67d8f50330.png";